import React from 'react';

const PayrollReports = () => {
  return (
    <div className="p-4">
      <h2 className="text-xl font-semibold">Payroll Reports</h2>
      <p className="text-sm text-gray-600">Payroll reporting pages will be added here.</p>
    </div>
  );
};

export default PayrollReports;
